<template>
<modal-dialog
	:modal-visible="visible"
	:title="'Send '+documentType+' By Email'"
	confirm-button-text="Send"
	modal-size="modal-lg"
	v-on:confirm="emailDocument"
	v-on:closeModal="$emit('closeModal')">
	
	<template v-if="multiCustomers">

		<div>
			<h4>Add a Customer</h4>

			<form-group label="Customer"
				col-class="col-sm-6 col-md-4">
				<div class="d-flex">
					<field 
						:params="{
							type: 'select',
							options: optionify(customers,'name')
						}"
						v-model="addCustomerForm.selectedId"
						v-on:change="customerSelected">
					</field>
					<div v-if="addCustomerForm.subContacts.length == 0">
						<button type="button" class="btn btn-primary btn-attached" v-on:click="addCustomer">
							Add
						</button>
					</div>
				</div>
			</form-group>

			<form-group v-if="addCustomerForm.subContacts.length > 0"
				label="Recipients"
				col-class="col-sm-6 col-md-4">
				<div class="d-flex flex-wrap">
					<field 
						v-model="addCustomerForm.selectedSubContacts"
						:params="{
							type: 'select-multi',
							options: documentEmailRecipients(selectedCustomer,addCustomerForm.subContacts)
						}">
					</field>
					<div>
						<button type="button" class="btn btn-primary btn-attached" v-on:click="addSubContacts">
							Add
						</button>
					</div>
				</div>
			</form-group>
		</div>
		
		<ul class="list-group mb-2">
			<li v-for="(contact,index) in recipientObjects" class="list-group-item list-group-item-action" v-on:click="removeMultiCustomerRecipient(index)">
				<div class="d-flex justify-content-between align-items-center">
					<div>
						<span v-if="'parentName' in contact">{{ contact.parentName }}: </span>{{ contact.name }} ({{ contact.email }})
					</div>
					<i class="fa fa-trash icon-button"></i>
				</div>
			</li>
		</ul>

	</template>
	<template v-else>
		<field v-if="customer && documentEmailRecipients(customer,customer.SubContacts).length > 0" 
			label="Recipients"
			col-class="col-sm-6 col-md-4"
			:params="{type:'select-multi',options:documentEmailRecipients(customer,customer.SubContacts)}"
			v-model="recipients">
		</field>
	</template>

	<field v-if="employees && userOptions(false, employees).length > 0" label="Employees"
		 col-class="col-sm-6 col-md-4"
		 :params="{type:'select-multi',options:userOptions(false, employees)}"
		 v-model="employeeRecipients">
	</field>

	<additional-email-addresses-field
		:heading="customer ? 'Additional Email Addresses' : 'Email Addresses'"
		v-model="additionalRecipientsArray">
	</additional-email-addresses-field>

</modal-dialog>
</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import AdditionalEmailAddressesField from "@/components/AdditionalEmailAddressesField"

import ContactMixins from "@/mixins/ContactMixins.js"

export default {
	name: "SendDocumentModal",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		AdditionalEmailAddressesField
	},
	mixins: [ContactMixins],
	props: [
		"documentType",
		"visible",
		"customer",       // Should have .SubContacts included
		"employees",       // Should be a list of Users
		"value",
		'multiCustomers', //boolean, activates the ability to send to multiple customers
		'customers', //list of customers, should have .SubContacts included	
	],
	data() {
		return {
			recipients: [],
			employeeRecipients: [],
			additionalRecipientsArray: [],
			recipientObjects: [],
			addCustomerForm: {
				selectedId: null,
				subContacts: [],
				selectedSubContacts: []
			}
		}
	},
	watch: {
		'value'() {
			this.resetRecipientsForm()
		},
		visible(isVisible) {
			if (isVisible) {
				this.resetRecipientsForm()
			}
		}
	},
	computed: {
		selectedCustomer() {
			return this.customers.find(customer => customer.id == this.addCustomerForm.selectedId)
		}
	},
	methods: {
		resetRecipientsForm() {
			this.recipients = []
			this.employeeRecipients = []
			this.additionalRecipientsArray = []
			this.recipientObjects = []
			this.addCustomerForm = {
				selectedId: null,
				subContacts: [],
				selectedSubContacts: []
			}
		},
		emailDocument() {
			let vm = this

			let payload = {
				recipients: this.recipients,
				employeeRecipients: this.employeeRecipients,
				additional: this.additionalRecipientsArray.join(","),
			}

			if (this.additionalRecipientsArray.length == 0 && this.recipients.length == 0 && this.employeeRecipients.length == 0)
				this.alertFail("Please choose a recipient")
			else
				this.$emit("send",payload)
		},
		removeMultiCustomerRecipient(index) {
			this.recipientObjects.splice(index,1)
			this.recipients.splice(index,1)
		},
		customerSelected(customerId) {
			//fetch subcontacts
			this.fetchSubContacts(customerId)
		},
		addCustomer() {
			this.recipients.push(this.addCustomerForm.selectedId)
			this.recipientObjects.push(this.customers.find(customer => customer.id == this.addCustomerForm.selectedId))
			this.addCustomerForm.selectedId = null
			this.addCustomerForm.subContacts = []
		},
		addSubContacts() {
			this.addCustomerForm.selectedSubContacts.forEach(sub => {
				this.recipients.push(sub)

				let subObject = this.addCustomerForm.subContacts.find(customer => customer.id == sub)
				subObject.parentName = this.customers.find(customer => customer.id == this.addCustomerForm.selectedId).name

				this.recipientObjects.push(subObject)
			})

			this.addCustomerForm.selectedId = null
			this.addCustomerForm.subContacts = []
			this.addCustomerForm.selectedSubContacts = []
		},
		fetchSubContacts(customerId) {
			let vm = this

			let params = {
				filters: [
					["contact_id",customerId]
				]
			}

			this.getJSON("Contact/get",params).then(response => {
				if (response.success)
					vm.addCustomerForm.subContacts = response.data
			})
		}
	}
}
</script>